<script>
    import { getContext }     from 'svelte'
    import _                  from 'lodash'
    import validate           from 'validate.js'
    import { Activity }       from '../../shared/inventory.js'
    import * as api           from '../../shared/api.js'
    import Dropdown           from '../../shared/Dropdown.svelte'
    import Item               from '../../shared/Item.svelte'
    import FieldError         from '../../shared/FieldError.svelte'
    import Duration           from '../../shared/Duration.svelte'
    import Consent            from './Consent.svelte'
    import LegitimateInterest from './LegitimateInterest.svelte'
    import Reference          from './Reference.svelte'
    import Projections        from './Projections.svelte'
    import Profile            from '../inventory/Profile.svelte'

    const ctx = getContext('activities')
    
    const options = [
        { id: 1 , name: 'CONSENT'                   , text: 'Consentimento'                 },
        { id: 2 , name: 'LEGITIMATE_INTEREST'       , text: 'Legítimo Interesse'            },
        { id: 3 , name: 'CONTRACT'                  , text: 'Obrigação Contratual'          },
        { id: 4 , name: 'LEGAL_OBLIGATION'          , text: 'Obrigação Legal'               },
        { id: 5 , name: 'PUBLIC_POLICY'             , text: 'Políticas Públicas'            },
        { id: 6 , name: 'RESEARCH'                  , text: 'Pesquisa'                      },
        { id: 7 , name: 'REGULAR_EXERCISE_OF_RIGHTS', text: 'Exercício Regular de Direitos' },
        { id: 8 , name: 'LIFE_PROTECTION'           , text: 'Proteção à Vida'               },
        { id: 9 , name: 'CREDIT_PROTECTION'         , text: 'Proteção ao Crédito'           },
        { id: 10, name: 'HEALTH_PROTECTION'         , text: 'Proteção à Saúde'              },
    ]

    const all_constraints = {
        basic: {
            purpose      : { presence: { allowEmpty: false, message: "campo obrigatório" } },
            "basis.name" : { presence: {                    message: "campo obrigatório" } }
        },
        consent : { "basis.variant.text"       : { presence: { allowEmpty: false, message: "campo obrigatório" } } },
        li      : { "basis.variant.interest"   : { presence: { allowEmpty: false, message: "campo obrigatório" } },
                    "basis.variant.necessity"  : { presence: { allowEmpty: false, message: "campo obrigatório" } },
                    "basis.variant.impact"     : { presence: { allowEmpty: false, message: "campo obrigatório" } },
                    "basis.variant.safeguards" : { presence: { allowEmpty: false, message: "campo obrigatório" } },
                    "basis.variant.balancing"  : { presence: { allowEmpty: false, message: "campo obrigatório" } } }
    }

    export let activity
    export let domain   
    export let inventory
    export let active
    export let empty = () => false

    let working   = false
    let error     = null
    
    $: disabled           = working
    $: enhanced           = new Activity(inventory, activity)
    $: split              = enhanced.splitIssues()
    $: basisOpt           = basisOptionFor     (activity)
    $: constraints        = defineConstraints  (activity)
    $: issues             = verifyIssues       (activity)
    $: actions            = actionsGiven       (activity, enhanced, split)
    
    // $: if(activity.id > 0) console.log(`d:${activity.duration}, u:${activity.unit}`)

    function basisOptionFor(it) {
        return options.find(op => op.name === it.basis.name)
    }

    function basisSelected(option) {
        
        const variantGiven = name => {
            switch (name) {
                case 'CONSENT'              : return { text: null, fields: true, operators: true }
                case 'LEGITIMATE_INTEREST'  : return { interest: null, necessity: null, impact: null, safeguards: null, balancing: null }
                default                     : return { reference: null }
            }
        }
        
        activity.basis = {
            name    : option.name,
            variant : variantGiven(option.name)
        }

        if(activity.basis.name === 'CONSENT') {
            activity.automatic = false
        }
    }

    function unitSelected(option) {
        activity.unit = option.value
    }

    function verifyIssues(activity) {

        const toDetail = ({ place, fields }) => {
            const names   = _.join(fields.map(f => f.name || f.definition), ", ") 
            const subject = fields.length == 1 ? 'campo' : 'campos' 
            return `${subject} '${names}' de ${place.name}`
        } 

        const mapFields = ([key, fields]) => {
            const place     = inventory.places().find(p => p.id == key)
            const filtered  = place.fields.filter(f => fields.find(i => i.field == f.id))
            const sensitive = filtered.filter(f => f.sensitive)
            if(sensitive.length > 0) {
                return { 
                    place, 
                    fields: sensitive 
                }
            }
        }

        if(activity && activity.basis.name === "LEGITIMATE_INTEREST") {
            const projection = inventory.projectionGiven(activity)
            const projected  = projection && projection.fields.filter(f => !f.deleted)
            const byPlace    = _.groupBy(projected, it => it.place)
            const sensitive  = Object.entries(byPlace).map(mapFields).filter(i => i)

            if(sensitive.length > 0) {
                return [{
                    title   : 'Base Legal Inadequada',
                    text    : 'Não é possível usar o Legítimo Interesse quando o tratamento envolve dados sensíveis',
                    details : sensitive.map(toDetail)
                }]
            } 
        }
    }

    function isDirty(it, copy) {
        return ! _.isEqual(it, copy)
    }

    function defineConstraints(activity) {
        const basic = all_constraints.basic
        switch(activity.basis.name) {
            case "CONSENT"              : return Object.assign({}, all_constraints.consent, basic)
            case "LEGITIMATE_INTEREST"  : return Object.assign({}, all_constraints.li, basic)
        }
        return basic
    }

    function actionsGiven(activity, enhanced, split) {
        const profileLabel = () => {
            const count = enhanced.profiles().length
            switch(count) {
                case 1 : return '1 Perfil'
                default: return `${count} Perfis`
            }
        }

        if(activity.id > 0) {

            return [{
                id              : 'registry',
                name            : 'Registros', 
                disabled        : true,
                triggerLoading  : true ,
                onClick         : () => {                 
                    return Promise.resolve(true)  
                }
            }, {
                id              : 'profiles',
                name            : profileLabel(),
                issues          : split.profile,
                triggerLoading  : false ,
                onClick         : () => {
                    return Promise.resolve(true) 
                }
            },{
                id              : 'projections',
                name            : 'Dados', 
                disabled        : false,
                issues          : split.projection,
                triggerLoading  : true ,
                onClick         : () => {                 
                    return Promise.resolve(true)  
                }
            }]
        } else {
            return []
        }
    }

    function onRemove(it) {
        working = true
        return api
            .post(`/inventory/domain/${domain.id}/delete/activity`, { id: it.id })
            .then(api.toJsonIf200)
            .then(json => {
                error   = null
                working = false
                ctx.setInventory(json)
                return Promise.resolve(true)
            })
            .catch(err => {
                working = false
                error   = err
                return Promise.reject("erro removendo atividade")
            })            
    }

    function onUpdate(it) {
        const obj = _.omitBy({
            group     : it.group     ,
            profiles  : it.profiles  ,
            automatic : it.automatic ,
            purpose   : it.purpose   ,
            basis     : it.basis     ,
            unit      : it.unit      ,
            duration  : parseInt(it.duration) ,
        }, i => _.trim(i) === '')

        const method = it.id === 0 ? 'add' : 'update'
        const data   = it.id === 0 ? obj   : { id: it.id, data: obj }

        working = true
        return api
            .post(`/inventory/domain/${domain.id}/${method}/activity`, data)
            .then(api.toJsonIf200)
            .then(json => {
                active  = -1
                working = false
                error   = null
                ctx.setInventory(json)
                if(it.id === 0) {
                    activity = empty()
                }
                return Promise.resolve(true)
            })
            .catch(err => {
                console.log(err)
                working = false
                error   = err
                return Promise.reject("erro adicionando atividade")
            })
    }

    function hasErrors(errors) {
        return Object.keys(errors).length > 0
    }

    function validateItem(it) {
        return validate(it, constraints, { fullMessages: false }) || {}
    }

</script>

<Item   debug={false} 
        bind:item={activity}
        bind:active
        {isDirty}
        {onRemove} 
        {onUpdate}
        {validateItem}
        {actions}>
    <span slot="header" >
        {#if activity.id > 0}        
            <span class="name truncate">
                {activity.purpose}
            </span>
            <span class="description">{basisOpt.text}</span>
        {/if}
    </span>
    <div slot="primary" let:errors>
        <div class="forms">
            <div>
                <h4 class="ui header">Informações</h4>
                <form class="ui big form" class:error={hasErrors(errors)}>
                    <div class="field" 
                         class:error={errors.purpose}
                         class:disabled>
                        <label for="purpose">Propósito</label>
                        <input  name="purpose"
                                bind:value={activity.purpose}
                                autocomplete="false">
                        <FieldError style="label" property={errors.purpose} />
                    </div>
                    <div class="field" 
                         class:disabled
                         class:error={errors["basis.name"]}>
                        <label for="">Base Legal</label>
                        <Dropdown {options} noOption={false} text="selecione" selected={basisOpt} onChange={basisSelected}/>
                        <FieldError style="label" property={errors["basis.name"]} />
                    </div>
                    <div class="two fields">
                        <Duration {disabled} {unitSelected} unit={activity.unit} bind:duration={activity.duration}/>
                    </div>
                    <div class="field" class:disabled={disabled || activity.basis.name === 'CONSENT'}>
                        <div class="ui toggle checkbox">
                            <input name="automatic" type="checkbox" bind:checked={activity.automatic}>
                            <label for="automatic" style="font-size: 1em">aplicação automática</label>
                        </div>
                    </div>
                </form>
            </div>
            {#if issues}
                <div>
                    <h4 class="ui header">Problemas</h4>
                    {#each issues as issue}
                        <div class="ui error message">
                            <div class="header">
                                {issue.title}
                            </div>
                            <p>{issue.text}</p>
                            <ul class="list">
                                {#each issue.details as detail}
                                    <li>{detail}</li>
                                {/each}
                            </ul>
                        </div>                    
                    {/each}
                </div>
            {:else if activity.basis.name}
                <div>
                    <h4 class="ui header">{basisOpt.text}</h4>
                    <form class="ui big form" class:error={hasErrors(errors)}>
                        {#if activity.basis.name === 'CONSENT'}
                            <Consent bind:activity {errors} />
                        {:else if activity.basis.name === 'LEGITIMATE_INTEREST'}
                            <LegitimateInterest bind:activity {errors}/>
                        {:else}
                            <Reference bind:activity />
                        {/if}
                    </form>
                </div>
            {/if}
        </div>
    </div>
    <div slot="secondary" let:action={action}>
        {#if action && activity.id === active}
            {#if action.id === "registry"}
                <span>Registros</span>
            {:else if "profiles" === action.id}
                <Profile 
                    {domain} 
                    {activity}
                    issues={split.profile}></Profile>
            {:else if "projections" === action.id}
                <Projections
                    {inventory} 
                    {domain}
                    {activity}
                    issues={split.projection}></Projections>
            {/if}
        {/if}
    </div>
</Item>
<style>    
    span[slot="header"] .name {
        display: flex;
        justify-content: space-between;
        margin-right: .5em;
    }

    h4.ui.header {
        color: #ccc;
        margin: 0 0 2em 0;
    }

    .forms {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin: 2em 0;
    }

    .form {
        _border: 1px solid red;
        max-width: 450px;
    }

    .form .field {
        margin-top: 2em;
    }

    .ui.form .field > label,
    .ui.toggle.checkbox label {
        color       : #000;
        font-size   : 1em;
        font-weight : 600;
    }
</style>
